import React from 'react';
import { Items } from '../../Routes';
import { Link } from 'react-router-dom';
import { Language } from '../../i18n/trans';
import { isLocatedTW } from '../../helper';
import { FormattedMessage } from 'react-intl';
import { useLocaleContext } from '../AppProvider/LocaleProvider';

const LangForTaiwan = (props) => {
    const { color, btnColor } = props.value
    const style = {
        span: `noti-icon-text ` + color,
        button: `btn w-md radius-0 ` + btnColor
    }
    return (
        <div className="topbar-custom">
            <ul className="list-inline float-right mb-0">
                <li className="list-inline-item language-list vertical-super">
                    <Link className="nav-link" to={Items.slice(-1)[0].path}>
                        <button type="button" className={style.button}>
                            <span className={style.span}><FormattedMessage id={Items.slice(-1)[0].name}/></span>
                        </button>
                    </Link>
                </li>
            </ul>
        </div>
    )
}
const LangForWorld = (props) => {
    const [ locale, setLocale ] = useLocaleContext()
    const { id, color, btnColor } = props.value
    return (
        <div className="topbar-custom">
            <ul className="list-inline float-right mb-0">
                <li className="list-inline-item dropdown language-list mr-3">
                    <a className="nav-link dropdown-toggle arrow-none" data-toggle="dropdown" role="button" aria-haspopup="false" aria-expanded="false">
                        <div className="list-inline">
                            <span id={id} className="list-inline-item"></span>
                            <span className={`list-inline-item language-title ` + color}>{Language[locale].name}</span>
                        </div>
                    </a>
                    <div className="dropdown-menu" aria-labelledby="dropdownMenu">
                        {Object.keys(Language).map(lang => {
                            return <span key={lang} className="dropdown-item" data-lang={lang} onClick={() => setLocale(lang)}><FormattedMessage id={`locale.` + lang}/></span>
                        })}
                    </div>
                </li>
                <li className="list-inline-item language-list vertical-super">
                    <Link className="nav-link" to={Items.slice(-1)[0].path}>
                        <button type="button" className={`btn w-md radius-0 ` + btnColor}>
                            <span className={`noti-icon-text ` + color}><FormattedMessage id={Items.slice(-1)[0].name}/></span>
                        </button>
                    </Link>
                </li>
            </ul>
        </div>
    )
}
const LanguageList = (props) => {
    const [ locatedTW, setLocatedTW ] = React.useState(localStorage.getItem('isLocatedTW') || undefined)
    const [ locale, setLocale ] = useLocaleContext()
    React.useEffect(() => {
        (async function() {
            try {
                const result = await isLocatedTW()
                if(result) {
                    setLocatedTW(true)
                    setLocale('zh-TW')
                }
            } catch (e) {
                console.error(e);
            }
        })();
    }, [])
    return (
        <> { locatedTW ? <LangForTaiwan value={props}/> : <LangForWorld value={props}/> } </>
    );
}

export default LanguageList;